<!--
 * @Author: wangzhu
 * @Date: 2021-12-29 12:49:04
 * @LastEditTime: 2022-12-29 16:04:18
 * @LastEditors: wangzhu10 wangzhu10@jd.com
-->
<template>
    <div id="page9-wrapper">
        <!-- <img src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-11-419W9uz7XSyZYLRCE.png" class="hourglass animate__animated animate__rotateIn animate__infinite"/> -->
         <!-- <img src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-26-18-22MNUi6IpoLtZRjpu.png" class="title-image  animate__animated animate__fadeInRight"/> -->
        <div class="page9-content animate__animated animate__rotateIn">
            <div class="page9-main">
                <!-- <img class="left-start animate__animated  animate__pulse animate__infinite" src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-11-04OwI56TWd56jzdhRYc.png"/> -->
                <!-- <img class='right-start animate__animated  animate__pulse animate__infinite' src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-11-05Rb9iQyRmcesWRHj.png"/> -->
            <!-- <div class="page-title">部门之光</div> -->
            <span>
                今年，你所在的部门<span class="report-num-text"> {{shortDept}}</span><br>
                全年累计发文<span class="report-num"> {{ reportData.deptData.postNum }} </span>篇<br>
                <template v-if="reportData.deptData.forums.length">成立圈子<span class="report-num"> {{ reportData.deptData.forums.length }} </span>个<br></template>
                参与讨论<span class="report-num"> {{ reportData.deptData.discussNum }} </span>次<br>
                浏览了<span class="report-num"> {{ reportData.deptData.readPostNum }} </span>篇文章<br>
                你在部门中贡献度排名第<span class="report-num"> {{ reportData.deptData.rank }}</span><br>
                <span v-if="reportData.deptData.rank > 1">贡献最多的同事是 <span class="report-num-text">{{ reportData.deptData.maxUser }}</span><br></span>
                一个人的努力是加法<br>
                一个团队的努力是乘法
            </span>
        </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Page5',
    props: {
        reportData: {
            required: true,
            default: () => {},
        },
    },
    computed: {
      shortDept() {
        const list = this.reportData.department.split('-')
        return list[list.length - 1]
      },
    forumData() {
            const res = {
                post: 0,
                read: 0,
                percentage: 0
            };
            for (let i = 0; i < this.reportData.forumData.length; i++) {
                const item = this.reportData.forumData[i];
                res.post += item.num;
                res.read += item.viewNum;
                res.percentage = item.percentage > res.percentage ? item.percentage.slice(0, 4) : res.percentage;
            }
            return res;
        },
    },
    methods: {
        handlePre() {
            this.$emit('pre');
        },
    },
};
</script>

<style lang="less" scoped>
#page9-wrapper {
  height: 100vh;
  width: 100%;
  padding: 0 20px;
  background-image: url('https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-16-43TX4Lu28VZmmrLx0U.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;

  .page9-content {
    // padding-top: 80px;
    font-size: 0.4rem;
    line-height: 2;
    color: #FAFAD7;
    // text-shadow: 1px 1px #f4e8e8;

    .page-title {
      width: 100px;
      color: #fff;
      background: #2D97E1;
      border-radius: 4px;
      margin-bottom: 40px;
      font-weight: 500;
      line-height: 1;
      padding: 6px 0;
      position: relative;
      text-align: center;

      &:after {
        position: absolute;
        display: block;
        content: '';
        width: 300px;
        height: 4px;
        bottom: -4px;
        border-radius: 4px;
        background: #D9F0F9;
      }
    }
  }

  .report-num {
    color: #f1f406;
    font-weight: 500;
    font-size: 0.55rem;
  }
      .report-num-text {
       color: #f1f406;
        font-weight: 500;
        font-size: 0.45rem; 
    }

  .page9-main {
    // width: 80%;
    // border-radius: 8px;
    margin: 3rem auto 0;
    // min-height: 45vh;
    // padding: 24px 0;
    // background-image: linear-gradient(#6577F8, #A0BDF4, #DEE5F2, );
    position: relative;

    .left-start {
      position: absolute;
      left: -1rem;
      top: -1rem;
      transform: translate(-50%, -50%);
      width: 2rem;
      height: 2rem;

    }

    .right-start {
      position: absolute;
      top: -60px;
      right: -20px;
      width: 1.5rem;
      height: 1.5rem;
    }
  }

  @keyframes rotoImg {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  .hourglass {
    animation: rotoImg 3s linear infinite;
    position: absolute;
    bottom: 48px;
    right: 24px;
    width: 1.5rem;
    height: 1.5rem;
    z-index: 10;
  }

  .title-image {
    height: 1.3rem;
    margin-top: 2rem;
  }
}
@media screen and (min-width: 1980px) {
  #page9-wrapper {
      .page9-main {
        margin-top: 20vh;
      }
    }
}
</style>
